import { Link } from "react-router-dom";
import { ArrowRight, Calculator } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const FranchiseCTA = () => {
  const { t } = useLang();
  return (
    <section id="franchise" className="py-20 md:py-28 bg-ink text-white" data-testid="franchise-cta-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal>
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.03] p-8 md:p-14 text-center">
            <span className="eyebrow">— {t.nav.franchise}</span>
            <h2 className="mt-4 font-display font-extrabold text-3xl md:text-5xl tracking-tight">{t.franchisingPage.title}</h2>
            <p className="mt-4 max-w-2xl mx-auto text-white/60 text-base md:text-lg leading-relaxed">{t.franchisingPage.subtitle}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/franchising" className="btn-primary" data-testid="promo-franchise-btn">{t.nav.franchise} <ArrowRight size={18} /></Link>
              <Link to="/simulatore" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 text-white text-sm font-semibold px-7 py-3.5 hover:bg-white hover:text-ink transition-colors duration-200" data-testid="promo-sim-btn">
                <Calculator size={18} /> {t.nav.simulator}
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
